import { useEffect } from 'react';
import { WORKSPACE_WINDOW_KIND } from '../electron-shared/workspace/workspace-descriptor';
import { useWorkspaceStore } from '../store/workspaceStore';
import { useProxyStore } from '../store/proxy-store';
import { setCurrentTenantId } from '../store/tenantStorage';

export function useWorkspaceBootstrap(): void {
  const setResolved = useWorkspaceStore((state) => state.setResolved);
  const setStatus = useWorkspaceStore((state) => state.setStatus);

  useEffect(() => {
    const workspaceApi = window.electronAPI?.workspace;

    if (!workspaceApi) {
      return;
    }

    let cancelled = false;

    void workspaceApi
      .getCurrent()
      .then((current) => {
        if (cancelled) {
          return;
        }

        if (!current) {
          setStatus('unscoped');

          return;
        }

        if (current.kind === WORKSPACE_WINDOW_KIND.WORKSPACE) {
          const { tenantId, httpPort, httpsPort } = current.workspace;

          setCurrentTenantId(tenantId);
          useProxyStore
            .getState()
            .updateSettings({ port: httpPort, httpsPort });
        }

        setResolved(current);
      })
      .catch((error: unknown) => {
        console.warn(
          '[useWorkspaceBootstrap] Failed to load the window workspace; running without workspace scoping',
          { error: error instanceof Error ? error : new Error(String(error)) },
        );

        if (!cancelled) {
          setStatus('unscoped');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [setResolved, setStatus]);
}
